import { Calendar, momentLocalizer } from "react-big-calendar";
import { useQuery, useMutation } from "react-admin";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";

const CalendarPage = () => {
  const { data } = useQuery({
    type: "getList",
    resource: "calendar",
    payload: { from: "2000-01-01", to: "2700-12-31" },
  });

  const handleSelectingSlot = ({ start, end, action }) => {
    if (action === "select") {
      //User input as time range
    } else {
      //User input by select specific date from month view
    }
    createEvent({
      type: "create",
      resource: "calendar",
      payload: {
        data: {
          locale: "en-US",
          type: "Appointment",
          desc: "Randomthing",
          name: "Appointment name",
          color: "#000",
          start_time: new Date(start),
          end_time: new Date(end),
          status: "Active",
          realm_id: "realm-5902ca0b0257bb14df426921",
          branch_id: "mbrnch-601bd807b27ba000ef17eab8",
        },
      },
    });
  };

  const [createEvent] = useMutation();

  let myEventList = [
    {
      id: 0,
      title: "All Day Event very long title",
      allDay: true,
      start: new Date(2021, 2, 1),
      end: new Date(2015, 3, 1),
    },
  ];
  const localizer = momentLocalizer(moment);

  //if (loading) return <Loading />;
  //if (error) return <Error />;
  //if (!data) return null;
  if (data) {
    myEventList = data.map((event, id) => {
      return {
        id: id,
        title: event.type === "bday" ? "Happy birthday" : "Appointment",
        start:
          event.type === "bday"
            ? new Date(event.birthdate)
            : new Date(event.start_time),
        end:
          event.type === "bday"
            ? new Date(event.birthdate)
            : new Date(event.end_time),
      };
    });
  }

  return (
    <div style={{ height: "80vh" }}>
      <Calendar
        localizer={localizer}
        events={myEventList}
        startAccessor="start"
        endAccessor="end"
        style={{ height: "80vh" }}
        selectable
        onSelectEvent={() => console.log("select")}
        onDoubleClickEvent={() => console.log("double click")}
        onSelecting={({ start, end }) => console.log("selecting...")}
        onSelectSlot={(slotInfo) => handleSelectingSlot(slotInfo)}
      />
    </div>
  );
};

export default CalendarPage;
